// extracted by mini-css-extract-plugin
export default {"wrapper":"Hu-z","addressLine":"Iu-z","fullName":"Ju-z"};